import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';
import { useNavigate } from 'react-router-dom'; // 1️⃣ Import useNavigate
import { ReactComponent as LinkArrowIcon } from '../assets/svg/icon-small-arrow.svg';
import { formatDateByLocale } from '../utils/dateUtils';

const Section1 = () => {
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const [faults, setFaults] = useState([]);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate(); // 2️⃣ Initialize the hook
  
  useEffect(() => {
    const fetchFaults = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/fault-errors`, {
          params: { status: 'New' } // Fetch only new faults
        });
        setFaults(response.data);
      } catch (error) {
        console.error('Error fetching faults:', error);
      }
    };

    fetchFaults();
  }, [apiBaseUrl]);

  const handleButtonClick = () => {
    navigate('/fault-error');
  };

  const highPriorityFaults = faults.filter(fault => fault.priority === 'High').slice(0, 4);
  const mediumPriorityFaults = faults.filter(fault => fault.priority === 'Medium').slice(0, 3);
  const lowPriorityFaults = faults.filter(fault => fault.priority === 'Low').slice(0, 3);
  const totalNewFaults = faults.length;

  return (
    <div className="db-box db-box_order-1">
      <div className="db-box__title-row">
        <button
          type="button"
          className="db-box__title-btn"
          aria-label="Newly reported errors"
          id="errors"
          onClick={handleButtonClick}
        >
          {t('Section1.ReportedErrors')} 
          <LinkArrowIcon />
        </button>
        <div className="db-box__title-stat">{totalNewFaults} {t('Section1.Error')}</div>
      </div>

      <div className="db-box__section-header">{t('Section1.HighPriority')}</div>

      {highPriorityFaults.length > 0 ? (
        highPriorityFaults.map((fault, index) => (
          <div className="db-box__entry-container db-box__entry-container-red" key={index}>
            <div className="db-box__entry-row-top">
              <div className="db-box__label db-box__label-red">{t('Section1.BoxHighPriority')}</div>
              <div className="db-box__entry-date">
                {formatDateByLocale(Math.floor(fault.created / 1000), i18n.language)}
              </div>
            </div>
            <div className="db-box__entry-eqipment-name">{fault.machine}</div>
            <div className="db-box__entry-desc">{t('Section1.Fault')}: {fault.description.length > 50 ? fault.description.slice(0, 15) + '...' : fault.description}</div>
          </div>
        ))
      ) : (
        <div className="db-box__section-text">{t('Section1.NoHighPriority')}</div>
      )}


      <div className="db-box__section-header">{t('Section1.MediumPriority')}</div>

      {mediumPriorityFaults.length > 0 ? (
        mediumPriorityFaults.map((fault, index) => (
          <div className="db-box__entry-container db-box__entry-container-yellow" key={index}>
            <div className="db-box__entry-row-top">
              <div className="db-box__label db-box__label-yellow">{t('Section1.BoxMediumPriority')}</div>
              <div className="db-box__entry-date">
                {formatDateByLocale(Math.floor(fault.created / 1000), i18n.language)}
              </div>
            </div>
            <div className="db-box__entry-eqipment-name">{fault.machine}</div>
            <div className="db-box__entry-desc">{t('Section1.Fault')}: {fault.description.length > 50 ? fault.description.slice(0, 15) + '...' : fault.description}</div>
          </div>
        ))
      ) : (
        <div className="db-box__section-text">{t('Section1.NoMediumPriority')}</div>
      )}

      <div className="db-box__section-header">{t('Section1.LowPriority')}</div>

      {lowPriorityFaults.length > 0 ? (
        lowPriorityFaults.map((fault, index) => (
          <div className="db-box__entry-container db-box__entry-container-green" key={index}>
            <div className="db-box__entry-row-top">
              <div className="db-box__label db-box__label-green">{t('Section1.BoxLowPriority')}</div>
              <div className="db-box__entry-date">
                {formatDateByLocale(Math.floor(fault.created / 1000), i18n.language)}
              </div>
            </div>
            <div className="db-box__entry-eqipment-name">{fault.machine}</div>
            <div className="db-box__entry-desc">{t('Section1.Fault')}: {fault.description.length > 50 ? fault.description.slice(0, 15) + '...' : fault.description}</div>
          </div>
        ))
      ) : (
        <div className="db-box__section-text">{t('Section1.NoLowPriority')}</div>
      )}
    </div>
  );
};

export default Section1;
